import axios from "axios";
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl, EndPoints } from "../../../api";
import {
  BackendLogo,
  DownloadIcon,
  FrontendLogo,
  Logo,
  ProductDesignLogo,
  RouteIcon,
  Web3Logo,
} from "../../../assets";
import { StepperHeader } from "../../../components";
import { localStoreName } from "../../../utils/constants";

export const DashboardHome = () => {
  const renderLogo = useCallback((role) => {
    switch (role) {
      case "web-3":
        return <Web3Logo />;
      case "frontend-development":
        return <FrontendLogo />;
      case "backend-development":
        return <BackendLogo />;
      case "product-design":
        return <ProductDesignLogo />;
      default:
        <Logo />;
    }
  }, []);
  const [links, setLinks] = useState({});
  const [curriculumUrl, setCurriculumUrl] = useState("");
  const [personalityTextUrl, setPersonalityTextUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentStage, setCurrentStage] = useState(1);

  const thisYear = new Date().getFullYear();
  const userDetailsFromLocal = JSON.parse(
    localStorage.getItem(localStoreName) ?? "{}"
  );

  axios.defaults.headers["x-auth-token"] = userDetailsFromLocal?.token;

  const isLinkAlreadySubmitted =
    userDetailsFromLocal?.technical_test?.submitted_urls
      ?.personality_test_url &&
    userDetailsFromLocal?.technical_test?.submitted_urls?.technical_test_url;

  useEffect(() => {
    if (userDetailsFromLocal !== "{}" && isLinkAlreadySubmitted) {
      setCurrentStage(2);
    }

    return () => {};
  }, [userDetailsFromLocal, isLinkAlreadySubmitted]);

  const getQuestion = async () => {
    try {
      let result = await axios.get(
        `${baseUrl}/users/technical-test?year=${thisYear}`
      );
      setCurriculumUrl(result?.data?.data?.initial_urls?.prep_curriculum_url);
      setPersonalityTextUrl(
        result?.data?.data?.initial_urls?.personality_test_url
      );

      sessionStorage.setItem(
        "techQ",
        JSON.stringify(result?.data?.data?.technical_test_question?.quiz ?? "")
      );
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    getQuestion();

    return () => {};
  }, []);

  const [date, setDate] = useState({
    d: "00",
    h: "00",
    m: "00",
    s: "00",
  });

  useEffect(() => {
    let timer = setInterval(() => {
      let end = JSON.parse(localStorage.getItem(localStoreName))?.technical_test
        ?.ended_at;
      var countDownDate = new Date(end).getTime();
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, Secutes and seconds
      let d = Math.floor(distance / (1000 * 60 * 60 * 24));
      let h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let s = Math.floor((distance % (1000 * 60)) / 1000);

      setDate({ d, h, m, s });
    }, 1000);

    if (Number(date.s) < 0) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleChange = (e) => {
    setLinks({ ...links, [e.target.id]: e.target.value });
  };

  const pattern =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=" "]*)$/;

  const testTechLink = pattern.test(links?.technical_test_url);
  const testPersonalityLink = pattern.test(links?.personality_test_url);

  //submit links
  const submitLink = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      if (JSON.stringify(links) !== "{}" && testPersonalityLink) {
        let result = await axios.patch(EndPoints.submitLinks, links);
        if (result?.data?.success) {
          toast.success(result?.data?.message);
          setCurrentStage(2);
        }
        setLoading(false);
      } else {
        toast.error("Please submit a valid url");
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="mx-5 my-5 py-5 d-flex items-center">
        {renderLogo(userDetailsFromLocal?.others?.learning_path)}
        <StepperHeader stage={currentStage} />
      </div>

      <div
        className="row pt-5"
        // style={{ pointerEvents: Number(date.s) < 0 ? "none" : "" }}
      >
        <div className="col-md-6 col-lg-4 dashboardCard">
          <div className="border shadow-sm relative rounded overflow-hidden position-relative h-100">
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cardColor"
            >
              <circle cx="40" cy="20" r="40" fill="#FFD847" />
              {/* refactor to render color */}
            </svg>

            {/* header */}
            <div
              className="rounded-pill darkBG px-4 py-3 mt-5 noLeft d-flex align-items-center"
              style={{ width: "60%" }}
            >
              <p className="h3 mb-0">Resources</p>
            </div>

            <div className="p-4 text-muted">
              <span>
                This resource is designed to provide you with enough knowledge
                about the entry requirements of the program. This curriculum
                covers the basics of our culture and soft skills that will give
                you a competitive edge during the screening process as well as
                basic computer science concepts.
              </span>
            </div>

            <div
              className="p-4 d-flex align-items-center position-absolute w-100"
              style={{ bottom: "0" }}
            >
              <a
                href={curriculumUrl}
                className="dark mb-0 font-weight-bold mr-3"
                style={{ color: "black", textDecoration: "none" }}
                target="_blank"
              >
                Preparation Curriculum.doc
              </a>
              <a
                href={curriculumUrl}
                className="dark mb-0 font-weight-bold"
                style={{ color: "black", textDecoration: "none" }}
                target={"_blank"}
                rel="noreferrer"
              >
                <DownloadIcon />
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 dashboardCard">
          <div className="border shadow-sm relative rounded overflow-hidden position-relative h-100">
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cardColor"
            >
              <circle cx="40" cy="20" r="40" fill="#F56B58" />
              {/* regactor to render color */}
            </svg>

            {/* header */}
            <div
              className="rounded-pill darkBG px-4 py-3 mt-5 noLeft d-flex align-items-center"
              style={{ width: "60%" }}
            >
              <p className="h3 mb-0">Test</p>
            </div>

            <div className="p-4 text-muted">
              <span>
                To gain a better knowledge of your Technical strength and an
                overview of your personality traits.
              </span>
            </div>

            <div className="p-4 position-absolute w-100" style={{ bottom: 0 }}>
              <a
                target={"_blank"}
                rel="noreferrer"
                href={personalityTextUrl}
                className="d-flex align-items-center justify-content-between pb-3 text-decoration-none"
              >
                <p className="dark mb-0 mr-3 font-weight-bold">
                  {" "}
                  Personality Test
                </p>
                <RouteIcon />
              </a>

              <Link
                to="/technical-test"
                className="d-flex align-items-center justify-content-between text-decoration-none"
              >
                <p className="dark mb-0 mr-3 font-weight-bold">
                  Technical Test
                </p>
                <button className="btn btn-dark btn-sm py-0 d-flex align-items-center">
                  Open
                  <i className="bi bi-arrow-right-short ml-1 h3 mb-0"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 dashboardCard">
          <div className="border shadow-sm relative rounded overflow-hidden position-relative h-100">
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cardColor"
            >
              <circle cx="40" cy="20" r="40" fill="#17255A" />
              {/* regactor to render color */}
            </svg>

            {/* header */}
            <div
              className="rounded-pill darkBG px-4 py-3 mt-5 noLeft d-flex align-items-center"
              style={{ width: "60%" }}
            >
              <p className="h3 mb-0">Links</p>
            </div>

            <div className="p-4 text-muted">
              <span>Attach the links to your respective tests below.</span>
            </div>

            <form
              className="p-4 position-absolute w-100"
              style={{ bottom: 0 }}
              onSubmit={submitLink}
            >
              <div className="form-group">
                <input
                  className="form-control form-control-sm small border p-3"
                  placeholder="Paste your personality test link"
                  id="personality_test_url"
                  onChange={handleChange}
                  // disabled={isLinkAlreadySubmitted}
                />
              </div>
              {/* <div className="form-group">
                <input
                  className="form-control form-control-sm small border p-3"
                  placeholder="Paste your technical test link"
                  id="technical_test_url"
                  onChange={handleChange}
                  // disabled={isLinkAlreadySubmitted}
                />
              </div> */}
              <button
                type="submit"
                className="btn orangeBG text-white w-100"
                // disabled={isLinkAlreadySubmitted}
              >
                {loading ? "Loading..." : `Submit test`}
                <i className="bi bi-check-lg ml-3"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
